module.exports = __webpack_public_path__ + "img/astral-txt_15.8a7018e7.svg";